import styled from 'styled-components';
import {textSizes} from '@stencil/build-theme';
import Image from '@stencil/image';

export const LOSCardContainer = styled.div`
  position: relative;
  border: 0.1rem solid #e4e4e4;
  padding: 18px;
  margin-top: 1.6rem;
  border-radius: 1rem;
`;

export const TextWrapper = styled.span``;

export const TitleText = styled.span<{titleTextColor?: boolean}>`
  ${textSizes.BaseW2}
  color: ${props => props?.titleTextColor || props.theme.colors.goTeal.base};
`;

export const SubText = styled.span`
  ${textSizes.BaseW1}
`;

export const SubTextLi = styled.li`
  ${textSizes.BaseW1}
  display: flex;
  align-items: baseline;
`;

export const SubTextLiIcon = styled(Image)`
  display: flex;
  width: 0.6rem;
  height: 0.6rem;
  margin-right: 0.5rem;
`;

export const TooltipWrapper = styled.div`
  position: absolute;
  bottom: 19px;
  right: 0.1rem;
  ${textSizes.BaseW1}
`;

export const TooltipText = styled.span`
  color: #2276e3;
`;

export const Tooltip = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;

  .tooltiptext {
    min-width: 30rem;
    visibility: hidden;
    width: 200px;
    border-radius: 0.8rem;
    background: #fff;
    box-shadow: 0 0.1rem 0.4rem rgba(0, 0, 0, 0.25);
    padding: 8px;
    position: absolute;
    z-index: 1;
    bottom: 125%; // Position above the tooltip element
    left: 50%;
    margin-left: -100px; // Center the tooltip
    opacity: 0;
    transition: opacity 0.3s;
    font-size: 14px;

    &::after {
      content: '';
      position: absolute;
      top: 100%; // At the bottom of the tooltip
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: #fff transparent transparent transparent;
    }
  }

  &:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
`;
